import { GridOptions } from 'ag-grid-community';
import { Skeleton } from 'antd';
import React, { ComponentType, FC, memo } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import styled from 'styled-components';

export type LoadingProps = {
  isPaginated: boolean;
};
const Loading = styled(Skeleton)`
  margin-left: var(--layout-03);
`;
const LoadingCell = memo(() => {
  return <Loading title paragraph={false} active />;
});

export const withCustomLoading = <T extends GridOptions>(
  Component: ComponentType<T>,
): FC<T & LoadingProps> => {
  const Next: FC<T & LoadingProps> = ({ isPaginated, ...props }) => {
    if (isPaginated) {
      return (
        <Component
          {...(props as any)}
          loadingCellRendererFramework={LoadingCell}
          isPaginated={isPaginated}
        />
      );
    }

    return <Component {...(props as any)} isPaginated={isPaginated} />;
  };

  return setDisplayName(wrapDisplayName(Component, 'withCustomLoading'))(Next);
};
